/* eslint-disable */
import _, { includes, isNull, isUndefined, trim, merge } from 'lodash';
import { LANGUAGE_KEY_FR, LANGUAGE_KEY_FR_QC } from '../constants';
import { graphql, useStaticQuery } from 'gatsby';
const strs = new Set(['EASYFINANCIAL', 'GOEASY', 'EASYHOME', 'EASYFINANCIÈRE']);

const PATHNAME_ARR = [
  '/fr/auto-loans/',
  '/fr/auto-loans',
  '/auto-loans/',
  '/auto-loans',
  '/en/auto-loans/',
  '/en/auto-loans',
  '/fr/prets-auto/',
  '/fr/prets-auto',
  '/prets-auto/',
  '/prets-auto',
  '/en/prets-auto/',
  '/en/prets-auto',
];

/**
 * Determines if the current build is for ROC Locale
 */
export const isROCLocale = () => {
  return process.env.GATSBY_LOCALE === 'roc';
};

/**
 * Determines if the current build is for QC Locale
 */
export const isQCLocale = () => {
  return process.env.GATSBY_LOCALE === 'qc';
};

/**
 * Filters the data set by looking at the node_locale property with the data
 * and matching it to the currently selected locale.
 */
export const filterDataByNodeLocal = (data, locale) => {
  let dataByLocale;
  if (isQCLocale()) {
    dataByLocale = data.filter((node) => node.node_locale === locale);
  } else {
    dataByLocale = data.filter((node) => node.node_locale === `${locale}-CA`);
  }
  return dataByLocale.pop();
};

export const getCurrencyFormat = (value, language, showDecimal = false) => {
  let formattedValue;
  const options = {
    minimumFractionDigits: showDecimal ? 2 : 0,
    maximumFractionDigits: showDecimal ? 2 : 0,
  };
  if (language === 'fr') {
    formattedValue = `${value.toLocaleString('fr-ca', options)} $`;
  } else {
    formattedValue = `$${value.toLocaleString('en', options)}`;
  }
  return formattedValue;
};

export const filterDataByContentFulID = (id, data) => {
  const dataByContentFulID = data.nodes.filter(
    (node) => node.contentful_id === id,
  );
  return dataByContentFulID;
};

/**
 * Returns number of times sub_str occured in main_str
 * @param {*} main_str
 * @param {*} sub_str
 * @returns
 */
export const countSubstringOccurancesInString = (main_str, sub_str) => {
  main_str += '';
  sub_str += '';

  if (sub_str.length <= 0) {
    return main_str.length + 1;
  }

  const subStr = sub_str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return (main_str.match(new RegExp(subStr, 'gi')) || []).length;
};

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

/**
 * @returns Return autoloan AB links based on Host
 */
export const getAutoLoanLink = (hostName, pathname, locale) => {
  let url = null;

  const frLocales = ['fr', 'fr-CA'];

  if (pathname && hostName && includes(PATHNAME_ARR, pathname)) {
    if (hostName === process.env.GATSBY_HOST_FR) {
      if (frLocales.includes(locale)) {
        url = process.env.GATSBY_AUTO_LOAN_URL_D2C_QC + `?lang=fr`;
      } else {
        url = process.env.GATSBY_AUTO_LOAN_URL_D2C_QC + `?lang=en`;
      }
    } else {
      url = process.env.GATSBY_AUTO_LOAN_URL_D2C_ROC;
    }
  }
  return url;
};

export const isAutoLoanPathQC = (hostName, pathname) => {
  let returnValue = false;
  if (pathname && hostName && includes(PATHNAME_ARR, pathname)) {
    returnValue = hostName === process.env.GATSBY_HOST_FR;
  }
  return returnValue;
};

export function isQC() {
  let host;
  if (typeof window !== 'undefined' || typeof document !== 'undefined') {
    host = window?.location?.hostname || document?.location?.hostname;
  }
  return host === process.env.GATSBY_HOST_FR;
}

export const isAutoLoanPath = (path) => PATHNAME_ARR.includes(path) && isQC();

const createGAAdsUrl = (data, hasParams, url) => {
  if (hasParams) {
    data = merge(getQueryObject(url), data);
  }
  let result = '';
  for (const [key, value] of Object.entries(data)) {
    result += `&${key}=${value}`;
  }
  result = result.replace('&', '?');
  const baseUrl = hasParams ? url.substring(0, url.indexOf('?')) : url;
  return `${trim(baseUrl)}${trim(result)}`;
};

export const addGAAdsParams = (url, isRedirect) => {
  if (typeof window !== 'undefined' && typeof url !== 'unedfined') {
    const gAAdsData = {};
    const hasParams = url?.includes('?');
    // Javascript optional chaining
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.forEach((value, key) => {
      if (key.includes('utm') || key.includes('gclid') || key.includes('flowname') || key.includes('op')) gAAdsData[key] = value;
    });
    if (Object.keys(gAAdsData).length > 0 && !isRedirect) {
      localStorage.setItem(
        'GAADs',
        JSON.stringify({
          value: gAAdsData,
          timestamp: new Date().getTime(),
        }),
      );
      return createGAAdsUrl(gAAdsData, hasParams, url);
    } else {
      const currentTime = new Date().getTime();
      const localStorageGAADsData = JSON.parse(localStorage.getItem('GAADs'));
      if (!localStorageGAADsData) {
        return url;
      } else if (currentTime - localStorageGAADsData.timestamp > 600000) {
        localStorage.removeItem('GAADs');
        return url;
      } else {
        return createGAAdsUrl(localStorageGAADsData.value, hasParams, url);
      }
    }
  } else {
    return url;
  }
};

/**
 * @returns to identify the the link is local path are external url
 *  @returns true - is local path,  false - is external path
 */
export const islocalPath = (url) => {
  return url?.indexOf('/') === 0 ? true : false;
};

/**
 * @returns  get  contentful global variable value
 *  @returns  return value if key exist
 */
export const getglobalValue = (url, data) => {
  let key = url.substring(1, url.indexOf(']'));
  const postFixValue = url.substring(url.indexOf(']') + 1);
  const findValue = (key + process.env.GATSBY_ENVIRONMENT).toLowerCase();
  return !isUndefined(data[findValue]) && !isNull(data[findValue])
    ? data[findValue] + postFixValue
    : url;
};

/**
 * @returns  this funtion used to find the value global variable or not
 *  @returns  return true or exist
 */
export const isglobalValue = (url) => {
  return url && url.includes('[') && url.includes(']') ? true : false;
};
export const LPModalAppearanceHendler = (chance) => {
  if (typeof document !== 'undefined') {
    if (document.referrer === '' || document.referrer.includes('easyfinanci')) {
      const val = Math.floor(Math.random() * (100 / chance)) + 1;
      return val === 1;
    } else {
      return false;
    }
  }
};

export const isHomePage = () => {
  if (typeof document !== 'undefined') {
    const pathname = document.location.pathname;
    return pathname === '/' || pathname === '/en/' || pathname === '/fr/';
  }
};

export const initializeLazyLoading = (isStoryBook = false) => {
  if (typeof document !== 'undefined') {
    if (!document.lazyLoadInstance) {
      document.lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy',
      });
    }
    if (isStoryBook === true) {
      document.lazyLoadInstance.loadAll();
    } else {
      document.lazyLoadInstance.update();
    }
  }
};

export const isTelephoneLink = (val) => {
  if (!val) return false;
  let result = false;
  const arr = ['tel'];
  arr.forEach((el) => {
    if (val.startsWith(el)) {
      result = true;
    }
  });
  return result;
};
export const filterDataByNodeLocalAndGlobalValue = (
  data,
  locale = 'en',
  url,
) => {
  if (url) {
    let filterData;
    url = trim(url);
    let key = url.substring(1, url.indexOf(']'));
    const postFixValue = url.substring(url.indexOf(']') + 1);

    if (isQCLocale()) {
      filterData = data.filter(
        (node) => node.node_locale === locale && node.internalName === key,
      );
    } else {
      filterData = data.filter(
        (node) =>
          node.node_locale === `${locale}-CA` && node.internalName === key,
      );
    }
    filterData = filterData.pop();
    const findValue = `globalVariable${process.env.GATSBY_ENVIRONMENT}`.toLowerCase();
    return !isUndefined(filterData) &&
      !isUndefined(filterData[findValue]) &&
      !isNull(filterData[findValue])
      ? `${trim(filterData[findValue])}${trim(postFixValue)}`
      : trim(url);
  }
};

export const getApplyNowStaticQueryData = () => {
  return useStaticQuery(graphql`
    query {
      applyNowData: allContentfulComponentGlobalApplicationVariables {
        nodes {
          globalvariabledev
          globalvariableprod
          globalvariableprvw
          globalvariableqa
          globalvariableuat
          globalvariabletest1
          globalvariabletest2
          globalvariabletest3
          internalName
          node_locale
        }
      }
    }
  `)
}

/*  Get Query Parameters Values from string   */
export const getQueryObject = (url) => {
  var qs = url.substring(url.indexOf('?') + 1).split('&');
  for (var i = 0, result = {}; i < qs.length; i++) {
    qs[i] = qs[i].split('=');
    result[qs[i][0]] = decodeURIComponent(qs[i][1]);
  }
  return result;
};


export function formatImage(src) {
  return new Promise((resolve, reject) => {
    let avif = new Image();
    avif.onload = () => resolve("avif");
    avif.onerror = () => {
      const webp = new Image();
      webp.src =
        "data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==";
      webp.onload = () => {
        resolve("webp");
      };

      webp.onerror = () => {
        reject('');
      };
    };
    avif.src = src;
  });
}


export function isSvgFormatImage(url) {
  return url.split('.').includes('svg') && url.endsWith(".svg")
}

export function getEnableArticleSchema(){
  if(typeof document !== 'undefined'){
    const articleSchemaImplementedPages = ["/bad-credit-loans", "/en/bad-credit-loans", "/fr/bad-credit-loans", "/debt-consolidation-loans", "/en/debt-consolidation-loans", "/fr/debt-consolidation-loans", "/installment-loans", "/en/installment-loans", "/fr/installment-loans"];
    const pathName = document?.location?.pathname;
    if(articleSchemaImplementedPages.includes(pathName.replace(/\/$/,''))) return true;
  }
  return false;
}


/* rich-results support functions - start */
export function getCleanText(text)  {
  if(text && typeof !isUndefined(text)) {
    const returnText =  text.replace( /[\r\n\t]+/gm, '' );
     return !isUndefined(returnText)? returnText : '';
  }
}

export function  recurseFind (findValues) {
  let returnStr = '';
  findValues.forEach((element) => {
    if (element?.nodeType === "text" &&  !isUndefined(element?.value) ) {
      returnStr = getCleanText(element?.value);
    } else {
       returnStr =  recurseFind(element?.content, true);
    }
  });
  return   returnStr;
};

export function  richResultObjectValues (content) {
  let finalString = "";
  content && content.forEach((element) => {
  const nestedData = element?.content;
   nestedData && nestedData.forEach((nestedVal) => {
      if (
        nestedVal?.nodeType === "text" &&
        !isUndefined(nestedVal?.value)
      ) {
        const cleanText =  getCleanText(nestedVal?.value);
        if(!isUndefined(cleanText) ) {
          finalString += getCleanText(nestedVal?.value);
        }
        
      } else {
       finalString += recurseFind(nestedVal?.content);
      }
    });
  });
 return finalString;
}

/* rich-results support functions - end */

/* social links */

export function getSocialLinks(requestMedia)  {
  const socialLinks = {
    roc: {
      facebookUrl: 'https://www.facebook.com/easyfinancialServices?campaign',
      twitterUrl: 'https://twitter.com/_easyfinancial',
      instagramUrl: 'https://www.instagram.com/easyfinancialservices/',
      youtubeUrl: 'https://www.youtube.com/@easyfinancialservices696',
      linkedInUrl: 'https://ca.linkedin.com/company/goeasyltd'
    },
    qc: {
      facebookUrl: 'https://www.facebook.com/serviceseasyfinanciere/',
      twitterUrl: '',
      instagramUrl: 'https://www.instagram.com/services_easyfinanciere/',
      youtubeUrl: '',
      linkedInUrl: '',
    },
  };

  return  process.env.GATSBY_LOCALE === 'qc' ? socialLinks['qc'][requestMedia] : socialLinks['roc'][requestMedia];
  
}

/**
 * @returns my account link based on locale
 */
export const getMyAccountLink = (locale) => {
  let url = null;
  const frLocales = [LANGUAGE_KEY_FR, LANGUAGE_KEY_FR_QC];
  if (frLocales.includes(locale?.currentLocale)) {
    url = process.env.GATSBY_MYACCOUNT_URL_FR;
  } else {
    url = process.env.GATSBY_MYACCOUNT_URL_EN;
  }
  return url;
};

export const getCurrentPagePath = () => {
  const PATHNAME = window.location.pathname;
  const PATHNAME_ARR = ['/', '/en/', '/en', '/fr/', '/fr'];
  if (!PATHNAME_ARR.includes(PATHNAME)) {
    const replaceObject = {
      '/en/': '/',
      '/fr/': '/',
    };
    return PATHNAME.replace(
      /\/en\/|\/fr\//gi,
      (matched) => replaceObject[matched],
    );
  }
  return '';

};
/* Updates contentful object having contentful_id property
 by adding sys { id : xxxxx } property*/
export const updateContent = (obj) =>{
  if (_.isObject(obj)) {
    if (_.has(obj, 'contentful_id')) {
      _.set(obj, 'sys', { id: obj.contentful_id });
    }
    _.forOwn(obj, updateContent);
  }
}
export const checkLivePreviewSetup = () => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('live-updates');
    const urlParams = new URLSearchParams(window.location.search);
    let enableLP = JSON.parse(sessionStorage.getItem('isLivePreviewEnabled'));
    const locale = urlParams.get('locale') || sessionStorage.getItem('locale') || 'en-CA';
    if (!enableLP) {
      const querySecret = urlParams.get('secret');
      enableLP = querySecret === process.env.GATSBY_CONTENTFUL_PREVIEW_API && document?.location?.ancestorOrigins?.[0] === process.env.GATSBY_CONTENTFUL_DOMAIN;
    }
    sessionStorage.setItem('isLivePreviewEnabled', enableLP);
    sessionStorage.setItem('locale', locale);
    return { isEnabled: enableLP, locale };
  }
  return { isEnabled: false, locale: 'en-CA' };
};

export const updatePreviewInspectorProps = (entryId, fieldId) => {
  let isLivePreviewEnabled = false;
  if (typeof window !== 'undefined') {
    isLivePreviewEnabled = Boolean(
      JSON.parse(sessionStorage.getItem('isLivePreviewEnabled')),
    );
  }
  return isLivePreviewEnabled
    ? {
        'data-contentful-entry-id': entryId,
        'data-contentful-field-id': fieldId,
      }
    : {};
};

// Function to check if a string matches a specific pattern
export const isStringMatching = (pattern) => {
  if (typeof window !== 'undefined') {
    const { pathname } = document.location;
  const regex = new RegExp(pattern);
  return regex.test(pathname);

  }
}

// Function to get PDF asset URL based on slug and locale
export const getPdfAssetUrl = (slug, locale, imageURl) => {

  if (!slug) return imageURl;
  let pdfUrl = slug;
  const isRocLocale = process.env.GATSBY_LOCALE === 'roc';
  const isQCLocale = process.env.GATSBY_LOCALE === 'qc';
  if ( (isRocLocale && locale === 'en') || (isQCLocale && locale === 'fr')) {
    pdfUrl = `/documents/${pdfUrl}.pdf`;
  } else {
    pdfUrl = `/documents/${locale}/${pdfUrl}.pdf`;
  }
  return pdfUrl;
};

// Flattens a Contentful rich text `raw` string to plain text.
export const richTextToPlainText = (raw) => {
  if (!raw) return '';
  try {
    const walk = (node) => {
      if (node?.nodeType === 'text') return node.value;
      return (node?.content || []).map(walk).join('');
    };
    return walk(JSON.parse(raw));
  } catch (e) {
    return '';
  }
};